import React, { useState } from 'react';

import ComboBox, { Props as ComboBoxProps } from 'ds/ComboBox';
import ComboBoxResult from 'ds/ComboBox/ComboBoxResult';
import { CompactBuildingFloor } from 'shared';

export type Props = Omit<ComboBoxProps<number>, 'results' | 'image' | 'onChange' | 'label'> &
  Partial<Pick<ComboBoxProps<number>, 'onChange' | 'label'>> & {
    floors: CompactBuildingFloor[];
    selectedFloorId?: number | null;
    onCreateNew?: VoidFunction;
  };

const BuildingFloorComboBox: React.FC<Props> = ({
  floors,
  selectedFloorId,
  label = 'Floor',
  onChange,
  onSelect,
  onCreateNew,
  ...props
}) => {
  const floor = floors.find(f => f.id === selectedFloorId);
  const [floorQuery, setFloorQuery] = useState<null | string>(floor?.name || null);

  return (
    <ComboBox
      required={false}
      label={label}
      placeholder="Floor"
      size="sm"
      results={[
        ...(floorQuery ? floors.filter(f => f.name.toLowerCase().includes(floorQuery.toLowerCase())) : floors).map(
          f => ({
            value: f.id,
            element: <ComboBoxResult label={f.name} key={f.id} query={floorQuery || ''} subLabel={`Level ${f.level}`} />
          })
        ),
        ...(onCreateNew
          ? [
              {
                value: -1, // Special value for create new
                element: <ComboBoxResult label="+ Create New Floor" key="create-new" query={floorQuery || ''} />
              }
            ]
          : [])
      ]}
      query={
        selectedFloorId && floorQuery === null
          ? floors.find(f => f.id === selectedFloorId)?.name || ''
          : floorQuery || ''
      }
      onChange={params => {
        setFloorQuery(params.value);
        onChange?.(params);
      }}
      onSelect={value => {
        setFloorQuery(null);
        if (value === -1 && onCreateNew) {
          onCreateNew();
        } else {
          onSelect(value);
        }
      }}
      showResultsWhenEmpty
      {...props}
    />
  );
};

export default BuildingFloorComboBox;
